import { env } from "@/shared/lib/env";

const BASE = `${env.supabaseUrl}/functions/v1`;

export const EDGE_URLS = {
  orderCreate: `${BASE}/order-create`,
  orderRead: `${BASE}/order-read`,
  orderAdmin: `${BASE}/order-admin`,
  pickupVerify: `${BASE}/pickup-verify`,
  orderReturn: `${BASE}/order-return`,
  s3Presign: `${BASE}/s3-presign`,
  broadcastSend: `${BASE}/broadcast-send`,
  adminCrud: `${BASE}/admin-crud`,
  adminAnalytics: `${BASE}/admin-analytics`,
  cartSync: `${BASE}/cart-sync`,
  profileUpdate: `${BASE}/profile-update`,
} as const;
